module.exports = __webpack_public_path__ + "img/carshina21_21.32b9ec25.jpg";